/**
 * Cart drawer: upgrade line to subscription + change selling plan (Shopify/Recharge compatible cart/change.js).
 * Uses theme cart:prepare-bundled-sections + cart:change like line-item-quantity.
 * Direct add (default variant): [data-pupps-direct-add-variant] uses cart/add.js — cart drawer upsell, PDP horizontal products, etc.
 */
(function () {
  function bundleSections() {
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );
    return sectionsToBundle;
  }

  function findLineItemForKey(lineKey) {
    var drawer = document.getElementById("cart-drawer");
    if (!drawer) return null;
    var nodes = drawer.querySelectorAll("[data-line-key]");
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute("data-line-key") === lineKey) {
        return nodes[i].closest("line-item");
      }
    }
    return null;
  }

  async function changeLineSellingPlan(lineKey, quantity, sellingPlanId, sourceEl) {
    var lineItem =
      (sourceEl && sourceEl.closest && sourceEl.closest("line-item")) ||
      findLineItemForKey(lineKey);
    if (lineItem) {
      lineItem.dispatchEvent(
        new CustomEvent("line-item:will-change", {
          bubbles: true,
          detail: { targetQuantity: Number(quantity) },
        })
      );
    }
    var sectionsToBundle = bundleSections();
    var body = {
      id: lineKey,
      quantity: Number(quantity),
      sections: sectionsToBundle,
    };
    if (sellingPlanId != null && sellingPlanId !== "") {
      body.selling_plan = sellingPlanId;
    }
    var res = await fetch(Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    var cart = await res.json();
    if (!res.ok) {
      console.error("Cart drawer plan change failed", cart);
      if (lineItem) {
        lineItem.dispatchEvent(new CustomEvent("line-item:error", { bubbles: true }));
      }
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      return;
    }
    // Do not dispatch line-item:change here. Selling-plan updates often get a new line key, so
    // quantity would read as 0 and LineItem would run the remove animation (flash) before cart:change refreshes.
    if (lineItem) {
      var pill = lineItem.querySelector("pill-loader");
      if (pill) pill.removeAttribute("aria-busy");
    }
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: { baseEvent: "cart-drawer-plan-change", cart: cart },
      })
    );
  }

  async function addUpsellVariant(variantId, sourceEl) {
    var sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );
    var formData = new FormData();
    formData.set("id", variantId);
    formData.set("quantity", "1");
    formData.set("sections", sectionsToBundle.join(","));
    formData.set("sections_url", Shopify.routes.root + "variants/" + variantId);
    var response = await fetch(Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: formData,
      headers: { "X-Requested-With": "XMLHttpRequest" },
    });
    var responseJson = await response.json();
    if (!response.ok) {
      sourceEl.dispatchEvent(
        new CustomEvent("cart:error", {
          bubbles: true,
          detail: { error: responseJson.description || responseJson.message },
        })
      );
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      return;
    }
    if (
      window.themeVariables.settings.cartType === "page" ||
      window.themeVariables.settings.pageType === "cart"
    ) {
      window.location.href = Shopify.routes.root + "cart";
      return;
    }
    var cartContent = await (await fetch(Shopify.routes.root + "cart.js")).json();
    cartContent.sections = responseJson.sections;
    sourceEl.dispatchEvent(
      new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items") ? responseJson.items : [responseJson],
          cart: cartContent,
        },
      })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: { baseEvent: "variant:add", cart: cartContent },
      })
    );
  }

  document.addEventListener("click", function (e) {
    var puppsAddBtn = e.target.closest("[data-pupps-direct-add-variant]");
    if (puppsAddBtn) {
      e.preventDefault();
      var variantId = puppsAddBtn.getAttribute("data-pupps-direct-add-variant");
      if (!variantId || puppsAddBtn.getAttribute("aria-busy") === "true") return;
      puppsAddBtn.setAttribute("aria-busy", "true");
      addUpsellVariant(variantId, puppsAddBtn).finally(function () {
        puppsAddBtn.removeAttribute("aria-busy");
      });
      return;
    }

    var btn = e.target.closest("[data-cart-drawer-upgrade]");
    if (!btn || !e.target.closest("#cart-drawer")) return;
    e.preventDefault();
    var lineKey = btn.getAttribute("data-line-key");
    var qty = parseInt(btn.getAttribute("data-quantity"), 10) || 1;
    var planId = btn.getAttribute("data-selling-plan-id");
    if (!lineKey || !planId) return;
    btn.setAttribute("aria-busy", "true");
    btn.disabled = true;
    changeLineSellingPlan(lineKey, qty, planId, btn).finally(function () {
      btn.removeAttribute("aria-busy");
      btn.disabled = false;
    });
  });

  document.addEventListener("change", function (e) {
    var sel = e.target.closest("[data-cart-drawer-plan-select]");
    if (!sel || !e.target.closest("#cart-drawer")) return;
    if (e.target !== sel) return;
    var lineKey = sel.getAttribute("data-line-key");
    var qty = parseInt(sel.getAttribute("data-quantity"), 10) || 1;
    var planId = sel.value;
    if (!lineKey || !planId) return;
    sel.setAttribute("aria-busy", "true");
    sel.disabled = true;
    changeLineSellingPlan(lineKey, qty, planId, sel).finally(function () {
      sel.removeAttribute("aria-busy");
      sel.disabled = false;
    });
  });
})();
